// portalLogService.ts
// v1.0 - S13-U2: Portal log sink -- ship client-side events to /api/portal/log - 2026-06-28
//
// Fire-and-forget: network errors are suppressed. Never throws.
// Usage:
//   import { logEvent, logPageView } from './portalLogService';
//   logEvent('button_click', { button: 'invite' });
//   logPageView('/dashboard/team');

import api from './api';

export interface PortalLogOptions {
  page?: string;
  sessionId?: string;
}

/**
 * Fire-and-forget POST to /api/portal/log.
 * Errors are silently suppressed -- telemetry must never block the UI.
 */
export async function logEvent(
  eventType: string,
  payload: Record<string, unknown>,
  options: PortalLogOptions = {},
): Promise<void> {
  try {
    await api.post('/portal/log', {
      event_type: eventType,
      payload,
      page:       options.page,
      session_id: options.sessionId,
    });
  } catch {
    // best-effort: suppress all errors
  }
}

/**
 * Log a page-view event with the current path.
 */
export async function logPageView(path: string, options: PortalLogOptions = {}): Promise<void> {
  return logEvent('page_view', { path }, options);
}
